import type * as Types from 'app/types/graphql';

export type CollectionEdgeSelectFragment = {
  node?: Types.Maybe<
    Pick<Types.Collection, 'baseID' | 'title' | 'handle' | 'publishedAt' | 'templateSuffix'> & {
      collectionMedia?: Types.Maybe<Pick<Types.CollectionMedia, 'src'>>;
    }
  >;
};

export type CollectionSelectFragment = Pick<
  Types.Collection,
  'baseID' | 'title' | 'handle' | 'publishedAt' | 'templateSuffix'
> & { collectionMedia?: Types.Maybe<Pick<Types.CollectionMedia, 'src'>> };

export const CollectionSelectFragmentDoc = `
    fragment CollectionSelect on Collection {
  baseID
  title
  handle
  publishedAt
  templateSuffix
  collectionMedia {
    src
  }
}
    `;
export const CollectionEdgeSelectFragmentDoc = `
    fragment CollectionEdgeSelect on CollectionEdge {
  node {
    ...CollectionSelect
  }
}
    `;
